import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://public.readdy.ai/ai/img_res/40beb105-aa73-4e53-a2f4-5cf10142dfbd.png";

const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Process", href: "#process" },
  { label: "Results", href: "#results" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/80 backdrop-blur-2xl border-b border-black/[0.06]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
          <img src={LOGO_URL} alt="BlueForceX AI" className="w-7 h-7 object-contain" />
          <span
            className={`text-sm font-semibold tracking-tight transition-colors duration-300 ${
              scrolled ? "text-bfx-primary" : "text-white"
            }`}
          >
            BlueForce<span className="text-bfx-accent">X</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleAnchor(e, link.href)}
              className={`text-xs font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap tracking-wide ${
                scrolled ? "text-[#444] hover:text-bfx-primary" : "text-white/70 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex">
          <a
            href="#cta"
            onClick={(e) => handleAnchor(e, "#cta")}
            className={`whitespace-nowrap text-xs font-semibold px-5 py-2 rounded-full transition-all duration-200 cursor-pointer ${
              scrolled
                ? "bg-bfx-primary text-white hover:bg-bfx-secondary"
                : "bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm border border-white/20"
            }`}
          >
            Schedule a Call
          </a>
        </div>

        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-bfx-primary" : "text-white"
          }`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-lg`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-black/[0.06] px-6 py-5 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleAnchor(e, link.href)}
              className="text-sm font-medium text-bfx-primary cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#cta"
            onClick={(e) => handleAnchor(e, "#cta")}
            className="whitespace-nowrap text-sm font-semibold px-6 py-3 rounded-full bg-bfx-primary text-white text-center cursor-pointer"
          >
            Schedule a Call
          </a>
        </div>
      )}
    </header>
  );
}